import { atom } from 'jotai'

export const nftMarketFiltersAtom = atom({})
export const nftMarketActivityFiltersAtom = atom({})
export const tryVideoNftMediaAtom = atom(true)
